import React from 'react'
import { Form, Button, Spinner } from 'reactstrap'
import { FormikProps } from 'formik'
import { useTranslation } from 'react-i18next'

import { useTheme } from 'hooks'
import { TextField, SelectField } from 'components/form'
import { useOrganisation } from 'api'
import { useMemo } from 'react'

interface Props extends FormikProps<VirtualSitePEE> {
  isLoading: boolean
}

export const SiteForm: React.FC<Props> = ({ isLoading, ...props }) => {
  const { t } = useTranslation()
  const theme = useTheme() as any
  const organisation = useOrganisation()
  const uorOptions = useMemo(() => {
    if (!organisation || !organisation.UorEnfants) return []
    return organisation.UorEnfants?.map((s) => ({
      value: s.id,
      label: s.UorNom,
    })).sort((a, b) => (a.label > b.label ? 1 : -1))
  }, [organisation])

  const isDisabled = isLoading || props.isSubmitting || Object.keys(props.touched).length === 0
  const hasError = Object.keys(props.errors).length > 0

  return (
    <Form
      onSubmit={props.handleSubmit}
      css={{
        section: {
          display: 'grid',
          gridGap: theme.spacing,
          gridTemplateColumns: 'repeat(2, 1fr)',
          paddingTop: theme.spacing,
          paddingBottom: theme.spacing * 2,
        },
        footer: {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          '>*': {
            display: 'flex',
            justifyContent: 'flex-end',
            button: { marginLeft: '0.6rem' },
          },
        },
      }}
    >
      <section>
        <TextField name="SiteName" label={t('contract.site.labels.siteName')} />
        {uorOptions?.length > 0 && (
          <SelectField
            name="SiteUorId"
            label={t('contract.site.labels.clientName')}
            options={uorOptions}
          />
        )}
      </section>

      <footer>
        <div />
        <div>
          <Button color="light" disabled={isDisabled} onClick={() => props.resetForm()}>
            {t('global.reset')}
          </Button>
          <Button type="submit" disabled={isDisabled || hasError}>
            {isLoading && <Spinner size="sm" style={{ marginRight: '.6rem' }} />}
            <span>{t('global.validate')}</span>
          </Button>
        </div>
      </footer>
    </Form>
  )
}
